/*
  AllSendsRequest.js - Networking for Sent SMS Items

  Author: Kyle Combeer (2020)
  Company: Virtual Ark
*/

// MODULES
import RequestRabbit from './RequestRabbit';

// CONFIGURATION
import config from '../Config';

const useAllMessagesRequest = () => {
  /*
    Gets Sent Items based on search criteria (if provided)
  */
  const searchAllSends = async (searchObject, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/report/allsends`;
      const headers = new Headers({ 'Content-Type': 'application/json' });
      const options = {
        method: 'POST',
        body: JSON.stringify(searchObject) || null,
        headers: headers,
      };

      // Request
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response.json();

      // Response
      if (response.status > 399 && response.status < 600) {
        errorHandler(responseJSON.error);
        return [];
      }
      return responseJSON;
    } catch (e) {
      errorHandler(e);
      return [];
    }
  };

  /*
    Gets single message based on sms id
  */
  const getSingleMessage = async (smsId, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/admin/report/allsends/${smsId}`;
      const options = {
        method: 'GET',
      };

      // Request
      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response.json();

      // Response
      if (response.status > 399 && response.status < 600) {
        errorHandler(responseJSON.error);
        return [];
      }
      return responseJSON;
    } catch (e) {
      errorHandler(e);
      return [];
    }
  };

  return { searchAllSends, getSingleMessage };
};

export default useAllMessagesRequest;
